module.exports = __webpack_public_path__ + "static/img/12.81273cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/12.jpg
// module id = L0Df
// module chunks = 1